import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Dashboard from '../components/Dashboard';
import useApi from '../hooks/useApi';

const EnrollmentStatusPage = () => {
  const navigate = useNavigate();
  const { useGetCredentials } = useApi();
  const { data: credentials, isLoading, isSuccess } = useGetCredentials();

  const handleNavigateToDealer = (bac, options = {}) => {
    if (!bac) return;
    navigate(`/dealer/${encodeURIComponent(bac)}`, { state: options });
  };

  useEffect(() => {
    if (isSuccess && (!credentials || credentials.length < 2)) {
      navigate('/settings', { replace: true });
    }
  }, [credentials, isSuccess, navigate]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', flexDirection: 'column', gap: 2 }}>
        <CircularProgress />
        <Box sx={{ color: 'text.secondary', fontSize: 14 }}>Loading…</Box>
      </Box>
    );
  }

  return <Dashboard onNavigateToDealer={handleNavigateToDealer} />;
};

export default EnrollmentStatusPage;
